var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { PendingPageView } from "./pendingPageView";
import { useNavigate } from "react-router-dom";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { DataCards } from "./DTO";
import { GetDocumentsStatistics } from "../../fnx/documentsStatistics/getDocumentsStatistics";
import { useDispatch, useSelector } from "react-redux";
import { getDocumentsStatisticsClearData } from "../../store/documentStatistics/actions";
import { quoteAll, quoteAllClearData } from "../../store/generateQuote/actions";
import { showErrorToast } from "../../fnx/showError";
import { useTranslation } from "react-i18next";
import showToast from "../../services/toast";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
export var PendingPage = function () {
    var t = useTranslation().t;
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var _a = React.useState(false), trigger = _a[0], setTrigger = _a[1];
    var _b = React.useState(DataCards), dataCard = _b[0], setDataCard = _b[1];
    var _c = useState([]), rows = _c[0], setRows = _c[1];
    var _d = React.useState(true), enable = _d[0], setEnable = _d[1];
    var _e = React.useState(1), page = _e[0], setPage = _e[1];
    var _f = React.useState(500000), limit = _f[0], setLimit = _f[1];
    var _g = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _g[0], setSeeToast = _g[1];
    var _h = GetDocumentsStatistics(trigger), loadingDocumentStatistics = _h.loadingDocumentStatistics, responseDocumentStatistics = _h.responseDocumentStatistics, errorDocumentStatistics = _h.errorDocumentStatistics;
    var _j = useSelector(function (state) { return ({
        responseAllQuote: state.Quote.responseAllQuote,
        errorAllQuote: state.Quote.errorAllQuote,
        loadingAllQuote: state.Quote.loadingAllQuote,
    }); }), responseAllQuote = _j.responseAllQuote, errorAllQuote = _j.errorAllQuote, loadingAllQuote = _j.loadingAllQuote;
    useEffect(function () {
        if (errorAllQuote) {
            showErrorToast(errorAllQuote, setSeeToast, t);
        }
    }, [errorAllQuote]);
    useEffect(function () {
        if (errorDocumentStatistics) {
            showErrorToast(errorDocumentStatistics, setSeeToast, t);
        }
    }, [errorDocumentStatistics]);
    useEffect(function () {
        setTrigger(true);
        getQuoteAll();
    }, []);
    useEffect(function () {
        if (responseDocumentStatistics === null || responseDocumentStatistics === void 0 ? void 0 : responseDocumentStatistics.statuses) {
            var updatedDataCard = dataCard.map(function (card) {
                var statusMatch = responseDocumentStatistics.statuses.find(function (status) {
                    if (card.id === "1" && status.status === "PENDING")
                        return true;
                    return card.id === "2" && status.status === "READY";
                });
                return __assign(__assign({}, card), { numericalTitle: statusMatch ? statusMatch.count : "0" });
            });
            setDataCard(updatedDataCard);
        }
        dispatch(getDocumentsStatisticsClearData());
    }, [responseDocumentStatistics]);
    // const setDataQuoteToRows = (responseAllQuote: RowsModel[]) => {};
    useEffect(function () {
        if (Array.isArray(responseAllQuote)) {
            var dataR = responseAllQuote === null || responseAllQuote === void 0 ? void 0 : responseAllQuote.map(function (item) {
                var _a, _b;
                return ({
                    id: item.id,
                    quotation: item.code,
                    certificate: item.policyId && ((_a = item.policyId) === null || _a === void 0 ? void 0 : _a.code),
                    names: "".concat(item.firstNameA, " ").concat(item.firstNameB),
                    lastNames: "".concat(item.lastNameA, " ").concat(item.lastNameB),
                    status: (_b = item.catalogStatusQuote) === null || _b === void 0 ? void 0 : _b.description,
                    productId: item.productId.id,
                });
            });
            setRows(dataR);
            dispatch(quoteAllClearData());
        }
    }, [responseAllQuote]);
    var getQuoteAll = function () {
        dispatch(quoteAll({
            enable: enable,
            page: page,
            limit: limit,
            profileDocumentsStatus: "PENDING",
        }));
    };
    var handleClickContextMenu = function (item, param) {
        switch (item.id) {
            case "1":
                if (param.row.status === "Cotizada" ||
                    param.row.status === "cotizada") {
                    navigate("/confirmationForm/".concat(param.row.id, "/true/false/").concat(param.row.productId, "/true"));
                }
                else {
                    navigate("/confirmationForm/".concat(param.row.id, "/false/false/").concat(param.row.productId, "/true"));
                }
                break;
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(AlertLoadingHeader, { loading: loadingDocumentStatistics || loadingAllQuote, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: "Cargando..." }), _jsx(PendingPageView, { title: "Documentos cliente", handleClickContextMenu: handleClickContextMenu, dataCard: dataCard, rows: rows })] }));
};
